/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tile_Levels_TitleInputs */



/**
* | output |
* | --- |
* | "Levels from real activity" |
*
* @param {Landing_Tile_Levels_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_tile_levels_title = /** @type {((inputs?: Landing_Tile_Levels_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tile_Levels_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уровни за настоящую активность")
	return /** @type {LocalizedString} */ ("Levels from real activity")
});